import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BulkTaxReportComponent} from './bulk-tax-report.component';


export const bulktaxReportRoutes: Routes = [
  {
    path: 'bulktaxReport',
    component: BulkTaxReportComponent,
    data: {
      'expectedRoles': ['Accountant', 'Accountant Admin']
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(bulktaxReportRoutes)],
  exports: [RouterModule]
})
export class BulkTaxReportRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/bulk-tax-report/bulk-tax-report-routing.module.ts